import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function Footer() {
  const { t } = useTranslation('customer');

  return (
    <footer className="mt-16 bg-sidebar text-sidebar-foreground">
      <div className="mx-auto max-w-7xl px-8 py-12">
        <div className="grid gap-8 sm:grid-cols-3">
          <div>
            <p className="font-display text-2xl text-accent">Bon Boca</p>
            <p className="mt-2 text-sm text-sidebar-foreground/80">{t('footer.tagline')}</p>
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-wider">{t('footer.discover')}</p>
            <ul className="mt-3 space-y-2 text-sm text-sidebar-foreground/80">
              <li>
                <span className="hover:text-accent transition-colors cursor-default">
                  {t('cuisineLabels.krioyo')}
                </span>
              </li>
              <li>
                <span className="hover:text-accent transition-colors cursor-default">
                  {t('cuisineLabels.caribbean')}
                </span>
              </li>
              <li>
                <span className="hover:text-accent transition-colors cursor-default">
                  {t('cuisineLabels.vegan')}
                </span>
              </li>
              <li>
                <span className="hover:text-accent transition-colors cursor-default">
                  {t('cuisineLabels.bakery')}
                </span>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-wider">
              {t('footer.forRestaurants')}
            </p>
            <ul className="mt-3 space-y-2 text-sm text-sidebar-foreground/80">
              <li>
                <Link className="hover:text-accent transition-colors" to="/manage">
                  {t('footer.manageYourRestaurant')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-accent transition-colors" to="/manage/onboarding">
                  {t('footer.addYourRestaurant')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-sidebar-foreground/10 pt-6">
          <div className="flex flex-wrap gap-4 text-xs text-sidebar-foreground/60">
            <Link className="hover:text-accent transition-colors" to="/legal/terms">
              {t('footer.terms')}
            </Link>
            <Link className="hover:text-accent transition-colors" to="/legal/privacy">
              {t('footer.privacy')}
            </Link>
            <Link className="hover:text-accent transition-colors" to="/legal/cookies">
              {t('footer.cookies')}
            </Link>
          </div>
          <p className="mt-4 text-xs text-sidebar-foreground/60">
            © {new Date().getFullYear()} Bon Boca · Made with sunshine in Willemstad
          </p>
        </div>
      </div>
    </footer>
  );
}
